<style lang="scss" scoped>
.bg {
  background: #fff;
  padding: 60px 30px;
}
.input-with-select /deep/ .el-input-group__prepend {
  width: 100px;
  background-color: #fff;
}
.addForm /deep/ {
  .el-form-item {
    margin-bottom: 40px;
  }
}
.bar {
  height: 38px;
  line-height: 38px;
  .item {
    cursor: pointer;
    padding: 0 20px;
    display: block;
    float: left;
    color: #9a9a9a;
    &.active {
      color: #173bcf;
    }
    &:hover {
      color: #173bcf;
    }
  }
  i {
    font-size: 14px;
  }
}
.block {
  padding: 0 0 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.article {
  display: inline-block;
  border: 1px solid #dcdfe6;
  position: relative;
  text-align: left;
  width: 300px;
  cursor: pointer;
  padding-bottom: 10px;
  .title {
    padding: 0 10px;
    box-sizing: border-box;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
  }
  .desc {
    padding: 8px;
    line-height: 19px;
  }
  .img {
    width: 100%;
    height: 160px;
  }
  &.multi {
    .first {
      position: relative;
      .title {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        color: #fff;
        background: rgba(0, 0, 0, 0.7);
      }
    }
    .other {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #dcdfe6;
      padding: 15px 0;
      &:last-child {
        border: none;
      }
      .title {
        font-size: 14px;
        line-height: 20px;
        height: 60px;
      }
      .img {
        flex-shrink: 0;
        margin-right: 10px;
        margin-left: 10px;
        width: 80px;
        height: 80px;
      }
    }
  }
}
.link {
  display: inline-block;
  width: 400px;
  height: 108px;
  border: 1px solid #bdc7db;
  padding: 20px 15px;
  position: relative;
  .title {
    color: #000;
    font-size: 18px;
    margin-bottom: 15px;
  }
  .info {
    width: 240px;
  }
  .desc {
    font-size: 16px;
    color: #9a9a9a;
  }
  .img {
    position: absolute;
    bottom: 20px;
    right: 15px;
    width: 80px;
    height: 80px;
  }
}
.sound {
  vertical-align: middle;
  display: inline-block;
  padding: 15px 20px;
  width: 240px;
  .iconyuyin {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
  }
}
.video {
  vertical-align: middle;
  display: inline-block;
  padding: 15px 20px;
  width: 240px;
  .el-icon-video-play {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
  }
}
.text {
  color: #353535;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  /deep/ .emoji {
    width: 26px;
    background: transparent !important;
    cursor: unset;
    vertical-align: -8px;
  }
}
</style>

<template>
  <div>
    <AlertTips />
    <div class="bg">
      <el-form ref="form" :model="form" label-width="100px" label-position="left" class="addForm">
        <el-form-item label="规则名称">
          <el-row>
            <el-col :span="20">
              <el-input v-model="form.name" placeholder="输入规则名称" maxlength="30"></el-input>
              <div style="color:#9A9A9A">规则名最多30个字</div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="关键词">
          <el-row v-for="(item,index) in form.keywords" :key="index">
            <el-col :span="20">
              <el-input
                placeholder="输入关键词"
                class="input-with-select mb20"
                v-model="item.keywords"
                maxlength="20"
              >
                <el-select v-model="item.match" slot="prepend" placeholder="请选择">
                  <el-option label="全匹配" :value="true">全匹配</el-option>
                  <el-option label="半匹配" :value="false">半匹配</el-option>
                </el-select>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-tooltip
                effect="dark"
                content="添加"
                placement="top"
                :open-delay="800"
                v-if="index == form.keywords.length - 1"
              >
                <el-button
                  icon="el-icon-plus"
                  circle
                  size="mini"
                  class="ml10"
                  @click="form.keywords.push({match:true,keywords:''})"
                ></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" :open-delay="800" placement="top">
                <el-button
                  icon="el-icon-minus"
                  circle
                  size="mini"
                  class="ml10"
                  @click="form.keywords.splice(index, 1)"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="回复内容">
          <template v-if="form.material.length">
            <el-row v-for="(item,index) in form.material" :key="index">
              <el-col :span="20">
                <template v-if="item.type == 1">
                  <div class="block">
                    <div class="text" v-html="JSON.parse(item.content.text)[0]"></div>
                    <el-button
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      class="ml10"
                      @click="form.material.splice(index, 1)"
                    ></el-button>
                  </div>
                </template>
                <template v-if="item.type == 2">
                  <div class="block">
                    <el-image
                      class="border middle"
                      style="width: 182px; height: 122px"
                      :src="item.content.thumbUrl"
                      fit="contain"
                    ></el-image>
                    <el-button
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      class="ml10"
                      @click="form.material.splice(index, 1)"
                    ></el-button>
                  </div>
                </template>
                <template v-if="item.type == 3">
                  <div class="block">
                    <div class="article multi middle">
                      <template v-if="item.content.news.length>1">
                        <div v-for="(item2,index) in item.content.news" :key="index">
                          <template v-if="!index">
                            <div class="first">
                              <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                              <div class="title line1">{{item2.title}}</div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="other">
                              <div class="title line3">{{item2.title}}</div>
                              <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div class="title line1">{{item.content.news[0].title}}</div>
                        <el-image :src="item.content.news[0].thumbUrl" lazy fit="cover" class="img"></el-image>
                        <div class="desc">{{item.content.news[0].digest}}</div>
                      </template>
                    </div>
                    <el-button
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      class="ml10"
                      @click="form.material.splice(index, 1)"
                    ></el-button>
                  </div>
                </template>
                <template v-if="item.type == 4">
                  <div class="block">
                    <div class="sound border line1">
                      <i class="iconfont iconyuyin middle mr10" @click="play(item.content)"></i>
                      <span>{{item.content.title}}</span>
                    </div>
                    <el-button
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      class="ml10"
                      @click="form.material.splice(index, 1)"
                    ></el-button>
                  </div>
                </template>
                <template v-if="item.type == 5">
                  <div class="block">
                    <div class="video border line1">
                      <i
                        class="iconfont el-icon-video-play middle mr10"
                        @click="playVideo(item.content.videoUrl)"
                      ></i>
                      <span>{{item.content.title}}</span>
                    </div>
                    <el-button
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      class="ml10"
                      @click="form.material.splice(index, 1)"
                    ></el-button>
                  </div>
                </template>
                <template v-if="item.type == 10">
                  <div class="block">
                    <div class="link">
                      <div class="info">
                        <div class="title line2">{{item.content.title }}</div>
                        <div class="desc line3">{{item.content.digest}}</div>
                      </div>
                      <img :src="item.content.thumbUrl" class="img" v-if="item.content.thumbUrl" />
                    </div>
                    <el-button
                      icon="el-icon-delete"
                      circle
                      size="mini"
                      class="ml10"
                      @click="form.material.splice(index, 1)"
                    ></el-button>
                  </div>
                </template>
              </el-col>
            </el-row>
          </template>
          <el-popover placement="right" width="600" trigger="hover">
            <div class="bar clearfix">
              <textAdd class="item" @confirm="confirm($event)">
                <i class="iconfont iconwenzi"></i>
                文字
              </textAdd>
              <imageLib class="item" @confirm="confirm($event)">
                <i class="iconfont icontupian"></i>
                图片
              </imageLib>
              <articleLib class="item" @confirm="confirm($event)">
                <i class="iconfont icontuwen"></i>
                图文
              </articleLib>
              <soundLib class="item" @confirm="confirm($event)">
                <i class="iconfont iconyuyin"></i>
                语音
              </soundLib>
              <videoLib class="item" @confirm="confirm($event)">
                <i class="iconfont iconshipin"></i>
                视频
              </videoLib>
              <linkAdd class="item" @confirm="confirm($event)">
                <i class="iconfont iconwailian"></i>
                外链消息
              </linkAdd>
            </div>
            <el-button icon="el-icon-plus" circle class="add" slot="reference"></el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="回复方式">
          <el-radio v-model="form.replyRule" :label="false">回复全部</el-radio>
          <el-radio v-model="form.replyRule" :label="true">随机回复一条</el-radio>
        </el-form-item>
      </el-form>
      <div class="alignc pt20">
        <el-button type="primary" class="mr10" @click="save()">保 存</el-button>
        <el-button type="info" class="ml10" @click="back">取 消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import imageLib from '@/components/lib/imageLib';
import articleLib from '@/components/lib/articleLib';
import soundLib from '@/components/lib/soundLib';
import videoLib from '@/components/lib/videoLib';
import linkAdd from '@/components/lib/linkAdd';
import textAdd from '@/components/lib/textAdd';
import soundManager from 'soundmanager2';
import AlertTips from '@/components/alertTips';
import utils from '@/utils.js';
export default {
  components: {
    imageLib,
    articleLib,
    soundLib,
    videoLib,
    linkAdd,
    textAdd,
    AlertTips,
  },
  computed: {},
  props: ['id'],
  watch: {
    'form.name': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 30) {
          this.form.name = oldval;
        }
      },
    },
  },
  data() {
    return {
      type: this.$route.path.split('/')[5],
      form: {
        name: '',
        replyRule: false,
        keywords: [
          {
            match: true,
            keywords: '',
          },
        ],
        material: [],
      },
    };
  },
  async mounted() {
    if (this.type == 'edit') {
      let res = await this.$http.get(
        `/api/${this.id}/autoreply/${this.$route.query.id}/keyword`,
      );
      console.log(res);
      this.form = res;
    }
  },
  methods: {
    confirm(item) {
      console.log(item);
      this.form.material.push(item);
    },
    play(content) {
      if (this.voice) {
        this.voice.stop();
        this.voice.destruct();
      }
      soundManager.soundManager.setup({
        onready: () => {
          this.voice = soundManager.soundManager.createSound({
            url: content.voiceUrl,
          });
          this.voice.play();
        },
        waitForWindowLoad: true,
      });
    },
    playVideo(url) {
      window.open(url);
    },
    async save() {
      this.form.material.map(v => {
        v.replyType = v.type;
        return;
      });
      console.log(JSON.stringify(this.form));
      if (this.type == 'creat') {
        let res = await this.$http.post(
          `/api/${this.id}/autoreply/keyword`,
          this.form,
        );
      } else {
        let res = await this.$http.put(
          `/api/${this.id}/autoreply/${this.$route.query.id}/keyword`,
          this.form,
        );
      }
      this.$message.success('保存成功');
      this.back();
    },
    back() {
      this.$router.back(-1);
    },
  },
};
</script>
